/* Drink International theme scripts */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Hero mosaic: rotate through every slide, five tiles at a time.
  function initMosaic(root) {
    var data = root.querySelector('script[type="application/json"]');
    if (!data) return;
    var slides;
    try { slides = JSON.parse(data.textContent); } catch (e) { return; }
    var tiles = root.querySelectorAll('.mosaic__tile');
    if (reduce || slides.length <= tiles.length) return;
    var seconds = parseInt(root.getAttribute('data-seconds'), 10) || 5;
    var tick = 0;
    setInterval(function () {
      if (document.hidden) return;
      tick++;
      tiles.forEach(function (tile, k) {
        var s = slides[(tick * tiles.length + k) % slides.length];
        tile.classList.add('is-fading');
        setTimeout(function () {
          var img = tile.querySelector('img');
          if (!img) { img = document.createElement('img'); tile.insertBefore(img, tile.firstChild); }
          var pill = tile.querySelector('.tag-pill');
          img.src = s.img; img.alt = s.label;
          if (s.srcset) img.srcset = s.srcset; else img.removeAttribute('srcset');
          pill.textContent = s.label;
          tile.href = s.url;
          tile.setAttribute('aria-label', s.label);
          tile.classList.toggle('is-pack', !s.photo);
          tile.classList.remove('is-fading');
        }, 350);
      });
    }, seconds * 1000);
  }

  // Brand page: "In stock only" toggle.
  function initStockFilter(root) {
    var box = root.querySelector('[data-stock-toggle]');
    var count = root.querySelector('[data-range-count]');
    var cards = root.querySelectorAll('[data-available]');
    function update() {
      var n = 0;
      cards.forEach(function (c) {
        var hide = box.checked && c.getAttribute('data-available') !== 'true';
        c.hidden = hide;
        if (!hide) n++;
      });
      if (count) count.textContent = n + (n === 1 ? ' product' : ' products');
    }
    if (box) { box.addEventListener('change', update); update(); }
  }

  // Product page: thumbnails.
  function initGallery(root) {
    var main = root.querySelector('.pdp__main img');
    root.querySelectorAll('[data-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        main.src = b.getAttribute('data-src');
        main.srcset = b.getAttribute('data-srcset') || '';
        root.querySelectorAll('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-mosaic]').forEach(initMosaic);
    document.querySelectorAll('[data-range]').forEach(initStockFilter);
    document.querySelectorAll('[data-gallery]').forEach(initGallery);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
